<template>
  <div class='Fuell-Overlay'>
    <div class='Fuell-Modal'>
      <div class='Fuell-Modal--window  centered'>
        <button
          class='Fuell-Modal--close-button'
          @click="handleClose"
        >
          <img
            :src="require('@/assets/img/icons/close.svg')"
            alt='close'
          >
        </button>
        <h3 class='Fuell-Modal--title'>{{$t('send_notification_tasks_modal_title')}}</h3>
        <div
          class="d-flex flex-column justify-content-between"
          v-if="!confirmSendFlag"
        >
          <span class="Fuell-Text"> {{$t('send_notification_tasks_modal_message')}}</span>
          <div class="d-flex flex-column mt-4">
            <p class="Fuell-Title">{{$t('send_notification_tasks_modal_message_radio_title')}}</p>
            <p class="Fuell-Text">{{$t('send_notification_tasks_modal_message_radio_message')}}</p>
            <input-radio
              :label="'send_notification_tasks_modal_radio_complete'"
              :value="'INCOMPLETE_TRANSACTIONS'"
              :itemValue="notificationType"
              @click="setNotificationType"
            >
              <template slot="extra-info">
                <span class="Fuell-Text Fuell-Text--bold">{{$t('send_notification_tasks_modal_radio_complete_italic')}}</span>
              </template>
            </input-radio>
            <input-radio
              :label="'send_notification_tasks_modal_radio_review'"
              :value="'PENDING_REVIEW_TRANSACTIONS'"
              :itemValue="notificationType"
              @click="setNotificationType"
            >
              <template slot="extra-info">
                <span class="Fuell-Text Fuell-Text--bold">{{$t('send_notification_tasks_modal_radio_review_italic')}}</span>
              </template>
            </input-radio>
          </div>
          <div class="d-flex justify-content-between mt-5">
            <button
              class="Fuell-Button w-100 ml-2 blue"
              :disabled="!notificationType"
              @click="toggleCloseConfirmFlag"
            >
              {{$t('send_notification_tasks_modal_message_send')}}
            </button>
          </div>
        </div>
        <div
          class="d-flex flex-column justify-content-between"
          v-else
        >
          <p class="Fuell-Text">{{$t('send_notification_tasks_confirm_modal_message')}}</p>
          <div class="d-flex justify-content-between mt-5">
            <button
              class="Fuell-Button w-100 mr-2"
              @click="closeModal"
            >{{$t('ACTION_CANCEL')}}</button>
            <button
              class="Fuell-Button w-100 ml-2 blue"
              @click="sendNotification"
            >{{$t('send_notification_tasks_confirm_modal_message_send')}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { postNotificationAlert } from '@/shared/_api'
import _modalHandlerMixin from '@/components/Commons/_mixins/_modalHandlerMixin'
import InputRadio from '@/components/Commons/Forms/InputRadio'

export default {
  name: 'SendNotifiactionTasks',
  components: {
    InputRadio
  },
  mixins: [_modalHandlerMixin],
  data () {
    return {
      notificationType: undefined,
      confirmSendFlag: false
    }
  },
  methods: {
    setNotificationType (event) {
      this.notificationType = event
    },
    handleClose () {
      this.closeModal()
    },
    toggleCloseConfirmFlag () {
      this.confirmSendFlag = !this.confirmSendFlag
    },
    async sendNotification () {
      const notificationAlert = { type: this.notificationType }
      await postNotificationAlert(notificationAlert)
      this.closeModal()
    }
  }
}

</script>

<style scoped>
.Fuell-Modal--window {
  max-width: 412px !important;
  width: 100%;
  padding: 24px;
  overflow: hidden !important;
}
.Fuell-Title,
.Fuell-Text {
  margin-bottom: 4px;
  line-height: 24px;
}
.Fuell-Text--bold {
  font-weight: 500;
  font-size: 15px;
  margin: 2px 4px;
}

label >>> .Label {
  font-weight: 300;
  font-size: 15px;
  line-height: 24px;
  color: var(--text-body);
}
</style>
